<template>
  <div class="container">
    <h1>Editace tlouštěk materiálů</h1>
  </div>
</template>

<script>
export default {
  name: "AdminThicknessView"
}
</script>

<style scoped>
</style>